services.service('ExternalScriptLoader', [
    '$q',
    function ($q) {

        function ExternalScriptLoader() {
            var self = this;

            function isLoaded(url) {
                const scripts = Array.from(document.getElementsByTagName("script"));
                return !!scripts.find(function (script) {
                    return script.getAttribute('src') === url
                });
            }

            function removeScript(url) {
                const scripts = Array.from(document.getElementsByTagName("script"));
                const script = scripts.find(function (script) {
                    return script.getAttribute('src') === url
                });
                if (script) {
                    script.parentNode.removeChild(script)
                }
            }

            this.load = function (url) {
                if (isLoaded(url)) {
                    return $q.resolve()
                }


                return $q(function (resolve, reject) {
                    const node = document.createElement('script');
                    node.src = url;
                    node.type = 'text/javascript';
                    node.async = false;
                    node.charset = 'utf-8';
                    document.getElementsByTagName('head')[0].appendChild(node);
                    node.onload = function () {
                        resolve()
                    };
                    node.onerror = function () {
                        removeScript(url);
                        reject();
                    }
                });
            }


        }

        return ExternalScriptLoader;

    }
]);
